import { create } from 'zustand';
import { User } from '@/api/types';
import {
  getTokens,
  setTokens as saveTokens,
  clearTokens as removeTokens,
  getUser,
  setUser as saveUser,
} from '@/utils/storage';

interface AuthState {
  user: User | null;
  accessToken: string | null;
  refreshToken: string | null;
  isAuthenticated: boolean;
  isLoading: boolean;
  pendingEmail: string | null;

  // Actions
  setUser: (user: User) => void;
  setTokens: (accessToken: string, refreshToken: string) => void;
  setPendingEmail: (email: string) => void;
  clearAuth: () => void;
  initialize: () => void;
}

export const useAuthStore = create<AuthState>((set) => ({
  user: null,
  accessToken: null,
  refreshToken: null,
  isAuthenticated: false,
  isLoading: true,
  pendingEmail: null,

  setUser: (user: User) => {
    saveUser(user);
    set({ user, isAuthenticated: true });
  },

  setTokens: (accessToken: string, refreshToken: string) => {
    saveTokens(accessToken, refreshToken);
    set({ accessToken, refreshToken, isAuthenticated: true });
  },

  setPendingEmail: (email: string) => {
    set({ pendingEmail: email });
  },

  clearAuth: () => {
    removeTokens();
    set({
      user: null,
      accessToken: null,
      refreshToken: null,
      isAuthenticated: false,
      pendingEmail: null,
    });
  },

  initialize: () => {
    const tokens = getTokens();
    const user = getUser<User>();

    if (tokens.accessToken && tokens.refreshToken) {
      set({
        accessToken: tokens.accessToken,
        refreshToken: tokens.refreshToken,
        user,
        isAuthenticated: true,
        isLoading: false,
      });
    } else {
      set({ isLoading: false });
    }
  },
}));
